import { InsightAction } from '@travelnest/merlin.info-panels';
import { Rule } from '@travelnest/merlin.rule';
import { Spacer } from '@travelnest/merlin.spacer';
import { Paragraph } from '@travelnest/merlin.typography';
import * as React from 'react';
import { ICalendarSource } from '../../../data/entities/calendar-source';
import { CalendarSourceDisplayBlock } from '../calendar-source/CalendarSourceDisplayBlock';
import { HelpLink } from '../help-link/HelpLink';
import { CalendarEducationModal } from './CalendarEducationModal';
import { CalendarSyncLauncher } from './CalendarSyncLauncher';

export interface ICalendarSyncProps {
	propertyId: number | string;
	calendarSources: ICalendarSource[];
	getIcalCalendarSources: (propertyId: number | string) => any;
	deleteCalendarSource: (propertyId: number | string, calendarSourceId: number) => any;
}

export const CalendarSyncComponent: React.FC<ICalendarSyncProps> = ({ propertyId, calendarSources, deleteCalendarSource }) => {
	const [modalOpen, setModalOpen] = React.useState<boolean>(false);

	const helpLinkUrl = 'https://travelnest.freshdesk.com/support/solutions/articles/101000362817-synchronise-your-travelnest-calendar-with-ical';

	const removeSource = async (source: ICalendarSource) => {
		if (source.id) {
			deleteCalendarSource(propertyId, source.id);
		}
	};

	return <div className="calendar-sync-component">
		{modalOpen && <CalendarEducationModal onCloseModal={() => setModalOpen(false)} />}
		<div className="calendar-sync-component__intro">
			<Paragraph fillParent="mid">
				Sync your calendar with an external platform
				such as Airbnb to minimise the risk of double
				bookings. Remember to import and export
				from each platform.
			</Paragraph>
			<Spacer />
			<HelpLink to={helpLinkUrl}>How to sync your external calendars</HelpLink>
		</div>
		<div className="calendar-sync-component__buttons">
			<CalendarSyncLauncher
				propertyId={propertyId}
				type="import"
			/>
			<CalendarSyncLauncher
				propertyId={propertyId}
				type="export"
			/>
		</div>
		<InsightAction buttonText="Read now" text="Tips on managing your calendar" onClick={() => setModalOpen(true)} />
		<div className="calendar-source-display__list">
			{
				calendarSources && calendarSources.length && calendarSources.map(
					(cs: ICalendarSource, index) =>
						<div key={index}>
							<Rule />
							<CalendarSourceDisplayBlock
								key={index}
								calendarSource={cs}
								onRemoveClick={removeSource} />
						</div>
				)
			}
		</div>
	</div>;
};
